
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_1u294_10",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_1u294_56",
  "badge-color-green": "awsui_badge-color-green_1yjyg_1u294_61",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_1u294_66",
  "badge-color-red": "awsui_badge-color-red_1yjyg_1u294_71",
  "badge-color-severity-critical": "awsui_badge-color-severity-critical_1yjyg_1u294_76",
  "badge-color-severity-high": "awsui_badge-color-severity-high_1yjyg_1u294_81",
  "badge-color-severity-medium": "awsui_badge-color-severity-medium_1yjyg_1u294_86",
  "badge-color-severity-low": "awsui_badge-color-severity-low_1yjyg_1u294_91",
  "badge-color-severity-neutral": "awsui_badge-color-severity-neutral_1yjyg_1u294_96"
};
  